<footer class="intake-footer">
  <div class="intake-footer__row">
    <span class="material-symbols-outlined intake-footer__icon">lock</span>
    <span class="intake-footer__label"> Secure &amp; Confidential </span>
  </div>
  <div class="intake-footer__note-wrap">
    <p class="intake-footer__note">
      Submitting this form does not create an attorney-client relationship. We will review your
      information to determine whether we can assist you, but no representation begins until we have
      completed a conflict check and you have signed an engagement agreement. Please do not share
      highly sensitive details about your situation in this form. Your information will be handled
      in accordance with our privacy policy.
    </p>
  </div>
  <!-- iOS Home Indicator Space -->
  <div class="intake-footer__spacer"></div>
</footer>
